<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-common-header></app-common-header>
    <div class="page-wrapper">
        <router-outlet></router-outlet>

    </div>
    <app-footer></app-footer>

</div>